/** A minimal, source-agnostic media descriptor the media components render.
 *  Map your domain object (BrandAsset, CalendarEvent, Piece, …) to this. */
export interface MediaItem {
  id: string;
  /** IMAGE | VIDEO | DOCUMENT — anything else renders as a document tile. */
  type: string;
  /** The full-resolution / playable URL. */
  url: string;
  /** Optional server-generated poster (used as the video poster / image src). */
  thumbnailUrl?: string | null;
  /** Optional video duration in seconds — rendered as a badge. */
  durationSec?: number | null;
  /** Display name, used for alt text and the lightbox caption. */
  filename?: string;
}

export function isVideo(item: { type: string }): boolean {
  return item.type?.toUpperCase() === "VIDEO";
}

export function isImage(item: { type: string }): boolean {
  return item.type?.toUpperCase() === "IMAGE";
}
